export const permissionsMap = {
    // Store
    READ_ACTIVE_ORDER: 'read:active_store',
    UPDATE_STORE_OPEN: 'update:store_open',
    CANCEL_STORE_ORDER: 'reject:order',
    ACCEPT_STORE_ORDER: 'accept:order',
    DELIVERY_STORE_ORDER: 'deliver:order', 
    PREPARE_STORE_ORDER: 'prepared:order',

    // History
    READ_STORE_HISTORY: 'read:history_store',
    DOWNLOAD_STORE_HISTORY: 'download:history_store',


    // Product
    READ_STORE_PRODUCT_ID: 'read:own_store_product',
    CREATE_OWN_STORE_PRODUCT: 'create:own_store_product',
    UPDATE_OWN_STORE_PRODUCT: 'update:own_store_product',
    UPDATE_OWN_STORE_PRODUCT_PRICE: 'update:own_store_product_price',
    UPDATE_OWN_STORE_PRODUCT_CATEGORY: 'update:own_store_product_category',
    UPDATE_OWN_STORE_PRODUCT_FLAVOR: 'update:own_store_product_flavor',
    UPDATE_OWN_STORE_PRODUCT_EXTRA: 'update:own_store_product_extra',
    UPDATE_OWN_STORE_PRODUCT_DISCOUNT: 'update:own_store_product_discount',
    UPDATE_OWN_STORE_PRODUCT_IMAGE: 'update:own_store_product_image',
    DELETE_OWN_STORE_PRODUCT: 'delete:own_store_product',
    DELETE_OWN_STORE_CATEGORY: 'delete:own_store_categories',
    UPDATE_OWN_STORE_CATEGORY: 'update:own_store_categories',

    

    // Schedule
    UPDATE_STORE_SCHEDULE: 'update:store_schedule',
    UPDATE_STORE_WEEKEND: 'update:store_weekend',
    CREATE_STORE_WEEKEND: 'create:store_weekend',
    READ_STORE_SCHEDULE: 'read:store_schedule',
    DELETE_STORE_WEEKEND: 'delete:store_weekend',


    // Permission
    READ_STORE_USER: 'read:store_user',
    CREATE_STORE_USER: 'create:store_user',
    UPDATE_STORE_USER: 'update:store_user',
    DELETE_STORE_USER: 'delete:store_user', 
}

export const rolePermissions = {

    'Administrador': Object.values(permissionsMap),
    
    'Coordinador': [
        // Store
        permissionsMap.READ_ACTIVE_ORDER,
        permissionsMap.CANCEL_STORE_ORDER,
        permissionsMap.ACCEPT_STORE_ORDER,
        permissionsMap.DELIVERY_STORE_ORDER,
        permissionsMap.PREPARE_STORE_ORDER,

        // History
        permissionsMap.READ_STORE_HISTORY,
        permissionsMap.DOWNLOAD_STORE_HISTORY,

        // Product
        permissionsMap.UPDATE_OWN_STORE_CATEGORY,
        permissionsMap.CREATE_OWN_STORE_PRODUCT,
        permissionsMap.UPDATE_OWN_STORE_PRODUCT,
        permissionsMap.UPDATE_OWN_STORE_PRODUCT_CATEGORY,
        permissionsMap.UPDATE_OWN_STORE_PRODUCT_FLAVOR,
        permissionsMap.UPDATE_OWN_STORE_PRODUCT_EXTRA,
        permissionsMap.UPDATE_OWN_STORE_PRODUCT_IMAGE,
        permissionsMap.READ_STORE_PRODUCT_ID,
        

        //Schedule
        permissionsMap.UPDATE_STORE_SCHEDULE,
        permissionsMap.UPDATE_STORE_WEEKEND,
        permissionsMap.CREATE_STORE_WEEKEND,
        permissionsMap.DELETE_STORE_WEEKEND,
        permissionsMap.READ_STORE_SCHEDULE,

        
    ],
    
    'Agente': [
        permissionsMap.READ_ACTIVE_ORDER,
        permissionsMap.CANCEL_STORE_ORDER,
        permissionsMap.ACCEPT_STORE_ORDER,
        permissionsMap.DELIVERY_STORE_ORDER,
        permissionsMap.PREPARE_STORE_ORDER,
        permissionsMap.READ_STORE_HISTORY,
        permissionsMap.READ_STORE_USER,
        permissionsMap.READ_STORE_PRODUCT_ID,
    ]
}

export const hasPermission = (permissionToCheck, userPermissions) => {
    const userRole = JSON.parse(localStorage.getItem('user'))?.data?.user?.role;
    
    if (userPermissions && Array.isArray(userPermissions) && userPermissions.includes(permissionToCheck)) {
        return true;
    }
    
    if (Array.isArray(userRole)) {
        for (const role of userRole) {
            if (rolePermissions[role] && rolePermissions[role].includes(permissionToCheck)) {
                return true;
            }
        }
    } else if (typeof userRole === 'string') {
        if (rolePermissions[userRole] && rolePermissions[userRole].includes(permissionToCheck)) {
            return true;
        }
    }
    
    return false;
}


export const checkPermission = (permissionRequired, permissions) => {
    const roleStorage = JSON.parse(localStorage.getItem('user'))?.data?.user?.role;

    
    if (!permissions || !roleStorage || !permissionRequired) return false
    try {
        return hasPermission(permissionRequired, roleStorage, permissions);
    } catch (error) {
        console.error('Error checking permissions:', error);
        return false;
    }
}

    